import * as VetsuRedirectContant from './VetsuRedirectContants';
import { VetsuRedirectState } from './VetsuRedirectTypes';

export default (state = VetsuRedirectContant.DEFAULT_STATE, action: any): VetsuRedirectState => {
  switch (action.type) {
    case VetsuRedirectContant.VetsuRedirectActionTypes.LOADED_VETSU_REDIRECT:
      return { ...state, vetsURedirectMap: action.payload, reloadVetsURedirectMap: false };
    case VetsuRedirectContant.VetsuRedirectActionTypes.LOADED_VETSU_REDIRECT_CONFIG:
      return {
        ...state,
        vetsURedirectConfigMap: action.payload,
        reloadVetsURedirectConfigMap: false,
      };
    case VetsuRedirectContant.VetsuRedirectActionTypes.LOAD_VETSU_REDIRECT_ERROR:
      return { ...state, reloadVetsURedirectMap: true };
    case VetsuRedirectContant.VetsuRedirectActionTypes.LOAD_VETSU_REDIRECT_CONFIG_ERROR:
      return { ...state, reloadVetsURedirectConfigMap: true };
    case VetsuRedirectContant.VetsuRedirectActionTypes.SELECT_VETSU_REDIRECT_CONFIG:
      return { ...state, selectedOption: action.payload };
    case VetsuRedirectContant.VetsuRedirectActionTypes.LOAD_FORM_VALUES:
      return { ...state, formValues: action.payload };
    default:
      return state;
  }
};
